// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analytics-dialog-container,
.analytics-dialog .mat-mdc-dialog-container .mdc-dialog__surface {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 90vh;
  width: 100%;
  max-width: 65vh;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  font-family: "Raleway", Arial, Helvetica, sans-serif;
}

.analytics-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  background: #f8f9fa;
  color: #333;
  border-bottom: 1px solid #e0e0e0;
  flex-shrink: 0;
  min-height: 60px;
}
.analytics-header .analytics-title {
  flex: 1;
  min-width: 0;
}
.analytics-header .analytics-title h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #333;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.analytics-header .close-button {
  background: none !important;
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
  color: #666;
  cursor: pointer;
  padding: 0 !important;
  margin-left: 16px;
  border-radius: 0 !important;
  min-width: 24px;
  min-height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease;
  --mat-mdc-button-persistent-ripple-color: transparent;
  --mat-mdc-button-ripple-color: transparent;
  --mdc-ripple-color: transparent;
  --mat-mdc-button-persistent-ripple-opacity: 0;
  --mat-mdc-button-ripple-opacity: 0;
}
.analytics-header .close-button:hover, .analytics-header .close-button:focus, .analytics-header .close-button:active {
  background: none !important;
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}
.analytics-header .close-button mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.analytics-content {
  flex: 1;
  overflow-y: auto;
  padding: 0;
  -webkit-overflow-scrolling: touch;
}
.analytics-content .mat-mdc-tab-group {
  height: 100%;
}
.analytics-content .mat-mdc-tab-group .mat-mdc-tab-body-wrapper {
  height: calc(100% - 48px);
}
.analytics-content .mat-mdc-tab-body-content {
  height: 100%;
  overflow-y: auto;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
}

.time-period-selector {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}
.time-period-selector label {
  font-weight: 600;
  color: #333;
  margin: 0;
  white-space: nowrap;
}
.time-period-selector .time-period-select {
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: white;
  font-size: 14px;
  min-width: 120px;
  cursor: pointer;
}
.time-period-selector .time-period-select:focus {
  outline: 2px solid #333;
  outline-offset: 2px;
}

.charts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  margin-bottom: 24px;
}
.charts-grid .chart-container {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.2s ease;
}
.charts-grid .chart-container:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.charts-grid .chart-container h4 {
  margin: 0 0 16px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  text-align: center;
}
.charts-grid .chart-container canvas {
  width: 100% !important;
  height: 300px !important;
  max-height: 300px;
}

.links-tab-body {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  height: 100%;
}

.links-empty-state {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 24px;
  text-align: center;
  color: #999;
}
.links-empty-state .links-empty-icon {
  font-size: 56px;
  width: 56px;
  height: 56px;
  color: #ccc;
  margin-bottom: 16px;
}
.links-empty-state .links-empty-title {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #666;
}
.links-empty-state .links-empty-sub {
  margin: 0;
  font-size: 13px;
  color: #aaa;
  max-width: 320px;
  line-height: 1.5;
}

.links-table-container {
  overflow-x: auto;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  background: white;
}
.links-table-container .links-table {
  width: 100%;
  border-collapse: collapse;
  margin: 0;
}
.links-table-container .links-table thead {
  background: #f8f9fa;
}
.links-table-container .links-table thead th {
  padding: 16px 12px;
  text-align: left;
  font-weight: 600;
  color: #333;
  font-size: 14px;
  white-space: nowrap;
  border-bottom: 2px solid #e0e0e0;
}
.links-table-container .links-table tbody tr {
  border-bottom: 1px solid #e0e0e0;
  transition: background-color 0.2s ease;
}
.links-table-container .links-table tbody tr:hover {
  background-color: #f8f9fa;
}
.links-table-container .links-table tbody tr:last-child {
  border-bottom: none;
}
.links-table-container .links-table tbody tr td {
  padding: 12px;
  font-size: 14px;
  color: #333;
  vertical-align: top;
}
.links-table-container .links-table tbody tr td.link-cell {
  max-width: 300px;
  word-break: break-all;
}
.links-table-container .links-table tbody tr td.link-cell a {
  color: #333;
  text-decoration: none;
  font-weight: 500;
}
.links-table-container .links-table tbody tr td.link-cell a:hover {
  text-decoration: underline;
  color: #000;
}
.links-table-container .links-table tbody tr td.clicks-cell {
  text-align: center;
  font-weight: 600;
  color: #333;
}

.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  color: #666;
}
.loading-spinner mat-spinner {
  margin-bottom: 16px;
}
.loading-spinner p {
  margin: 0;
  font-size: 14px;
}

@media (max-width: 768px) {
  .analytics-dialog-container {
    max-height: 100vh;
    max-width: 100vw;
    margin: 0;
    border-radius: 0;
    height: 100vh;
    width: 100vw;
  }
  .analytics-header {
    padding: 16px 20px;
    min-height: 56px;
  }
  .analytics-header .analytics-title h2 {
    font-size: 20px;
  }
  .analytics-header .close-button {
    min-width: 36px;
    min-height: 36px;
    margin-left: 12px;
  }
  .analytics-header .close-button mat-icon {
    font-size: 20px;
    width: 20px;
    height: 20px;
  }
  .analytics-content .mat-mdc-tab-body-content {
    padding: 16px 20px;
  }
  .time-period-selector {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 12px;
  }
  .time-period-selector .time-period-select {
    width: 100%;
    min-width: unset;
  }
  .charts-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .charts-grid .chart-container {
    padding: 16px;
  }
  .charts-grid .chart-container h4 {
    font-size: 14px;
    margin-bottom: 12px;
  }
  .charts-grid .chart-container canvas {
    height: 250px !important;
    max-height: 250px;
  }
  .links-table-container .links-table thead th {
    padding: 12px 8px;
    font-size: 12px;
  }
  .links-table-container .links-table tbody td {
    padding: 8px;
    font-size: 12px;
  }
  .links-table-container .links-table tbody td.link-cell {
    max-width: 200px;
  }
}
@media (max-width: 480px) {
  .analytics-dialog-container {
    max-height: 100vh;
    max-width: 100vw;
    margin: 0;
    border-radius: 0;
    height: 100vh;
    width: 100vw;
  }
  .analytics-header {
    padding: 12px 16px;
    min-height: 52px;
  }
  .analytics-header .analytics-title h2 {
    font-size: 18px;
  }
  .analytics-content .mat-mdc-tab-body-content {
    padding: 12px 16px;
  }
  .charts-grid .chart-container {
    padding: 12px;
  }
  .charts-grid .chart-container canvas {
    height: 200px !important;
    max-height: 200px;
  }
}
@media (orientation: landscape) and (max-height: 600px) {
  .analytics-dialog-container {
    max-height: 95vh;
    max-width: 80vw;
  }
  .analytics-content .mat-mdc-tab-body-content {
    padding: 12px 16px;
  }
  .charts-grid {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 16px;
  }
  .charts-grid .chart-container {
    padding: 12px;
  }
  .charts-grid .chart-container h4 {
    font-size: 14px;
    margin-bottom: 8px;
  }
  .charts-grid .chart-container canvas {
    height: 200px !important;
    max-height: 200px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .chart-container,
  .close-button,
  .links-table tbody tr {
    transition: none;
  }
}
@media (prefers-contrast: high) {
  .analytics-dialog-container {
    border: 2px solid #000;
  }
  .analytics-header {
    background: #f8f9fa;
    color: #000;
    border: 2px solid #000;
  }
  .chart-container {
    border: 2px solid #000;
  }
  .links-table {
    border: 2px solid #000;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/analyics/analytics.component.scss"],"names":[],"mappings":"AACA;;EAEE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;EACA,oDAAA;AAAF;;AAIA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,gCAAA;EACA,cAAA;EACA,gBAAA;AADF;AAGE;EACE,OAAA;EACA,YAAA;AADJ;AAGI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AADN;AAKE;EACE,2BAAA;EACA,wCAAA;EACA,uBAAA;EACA,2BAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,qDAAA;EACA,0CAAA;EACA,+BAAA;EACA,6CAAA;EACA,kCAAA;AAHJ;AAKI;EAGE,2BAAA;EACA,wCAAA;EACA,uBAAA;EACA,2BAAA;EACA,wBAAA;AALN;AAQI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,wCAAA;EACA,uBAAA;EACA,2BAAA;AANN;;AAYA;EACE,OAAA;EACA,gBAAA;EACA,UAAA;EACA,iCAAA;AATF;AAWE;EACE,YAAA;AATJ;AAWI;EACE,yBAAA;AATN;AAaE;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AAXJ;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AAbF;AAeE;EACE,gBAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;AAbJ;AAgBE;EACE,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAdJ;AAgBI;EACE,uBAAA;EACA,mBAAA;AAdN;;AAoBA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AAjBF;AAmBE;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,wCAAA;EACA,gCAAA;AAjBJ;AAmBI;EACE,0CAAA;AAjBN;AAoBI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAlBN;AAqBI;EACE,sBAAA;EACA,wBAAA;EACA,iBAAA;AAnBN;;AAyBA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;AAtBF;;AA0BA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AAvBF;AAyBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AAvBJ;AA0BE;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAxBJ;AA2BE;EACE,SAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAzBJ;;AA8BA;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;AA3BF;AA6BE;EACE,WAAA;EACA,yBAAA;EACA,SAAA;AA3BJ;AA6BI;EACE,mBAAA;AA3BN;AA6BM;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,gCAAA;AA3BR;AAgCM;EACE,gCAAA;EACA,sCAAA;AA9BR;AAgCQ;EACE,yBAAA;AA9BV;AAiCQ;EACE,mBAAA;AA/BV;AAkCQ;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AAhCV;AAkCU;EACE,gBAAA;EACA,qBAAA;AAhCZ;AAkCY;EACE,WAAA;EACA,qBAAA;EACA,gBAAA;AAhCd;AAkCc;EACE,0BAAA;EACA,WAAA;AAhChB;AAqCU;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;AAnCZ;;AA4CA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,WAAA;AAzCF;AA2CE;EACE,mBAAA;AAzCJ;AA4CE;EACE,SAAA;EACA,eAAA;AA1CJ;;AA+CA;EACE;IACE,iBAAA;IACA,gBAAA;IACA,SAAA;IACA,gBAAA;IACA,aAAA;IACA,YAAA;EA5CF;EA+CA;IACE,kBAAA;IACA,gBAAA;EA7CF;EA+CE;IACE,eAAA;EA7CJ;EAgDE;IACE,eAAA;IACA,gBAAA;IACA,iBAAA;EA9CJ;EAgDI;IACE,eAAA;IACA,WAAA;IACA,YAAA;EA9CN;EAoDE;IACE,kBAAA;EAlDJ;EAsDA;IACE,sBAAA;IACA,uBAAA;IACA,QAAA;IACA,aAAA;EApDF;EAsDE;IACE,WAAA;IACA,gBAAA;EApDJ;EAwDA;IACE,0BAAA;IACA,SAAA;EAtDF;EAwDE;IACE,aAAA;EAtDJ;EAwDI;IACE,eAAA;IACA,mBAAA;EAtDN;EAyDI;IACE,wBAAA;IACA,iBAAA;EAvDN;EA8DI;IACE,iBAAA;IACA,eAAA;EA5DN;EA+DI;IACE,YAAA;IACA,eAAA;EA7DN;EA+DM;IACE,gBAAA;EA7DR;AACF;AAmEA;EACE;IACE,iBAAA;IACA,gBAAA;IACA,SAAA;IACA,gBAAA;IACA,aAAA;IACA,YAAA;EAjEF;EAoEA;IACE,kBAAA;IACA,gBAAA;EAlEF;EAoEE;IACE,eAAA;EAlEJ;EAuEE;IACE,kBAAA;EArEJ;EA0EE;IACE,aAAA;EAxEJ;EA0EI;IACE,wBAAA;IACA,iBAAA;EAxEN;AACF;AA8EA;EACE;IACE,gBAAA;IACA,eAAA;EA5EF;EAgFE;IACE,kBAAA;EA9EJ;EAkFA;IACE,2DAAA;IACA,SAAA;EAhFF;EAkFE;IACE,aAAA;EAhFJ;EAkFI;IACE,eAAA;IACA,kBAAA;EAhFN;EAmFI;IACE,wBAAA;IACA,iBAAA;EAjFN;AACF;AAuFA;EACE;;;IAGE,gBAAA;EArFF;AACF;AAyFA;EACE;IACE,sBAAA;EAvFF;EA0FA;IACE,mBAAA;IACA,WAAA;IACA,sBAAA;EAxFF;EA2FA;IACE,sBAAA;EAzFF;EA4FA;IACE,sBAAA;EA1FF;AACF","sourcesContent":["// Analytics Dialog Container\n.analytics-dialog-container,\n.analytics-dialog .mat-mdc-dialog-container .mdc-dialog__surface {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  max-height: 90vh;\n  width: 100%;\n  max-width: 65vh;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n  font-family: \"Raleway\", Arial, Helvetica, sans-serif;\n}\n\n// Header Section\n.analytics-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  background: #f8f9fa;\n  color: #333;\n  border-bottom: 1px solid #e0e0e0;\n  flex-shrink: 0;\n  min-height: 60px;\n\n  .analytics-title {\n    flex: 1;\n    min-width: 0;\n\n    h2 {\n      margin: 0;\n      font-size: 24px;\n      font-weight: 600;\n      color: #333;\n      line-height: 1.2;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n\n  .close-button {\n    background: none !important;\n    background-color: transparent !important;\n    border: none !important;\n    box-shadow: none !important;\n    color: #666;\n    cursor: pointer;\n    padding: 0 !important;\n    margin-left: 16px;\n    border-radius: 0 !important;\n    min-width: 24px;\n    min-height: 24px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    transition: color 0.2s ease;\n    --mat-mdc-button-persistent-ripple-color: transparent;\n    --mat-mdc-button-ripple-color: transparent;\n    --mdc-ripple-color: transparent;\n    --mat-mdc-button-persistent-ripple-opacity: 0;\n    --mat-mdc-button-ripple-opacity: 0;\n\n    &:hover,\n    &:focus,\n    &:active {\n      background: none !important;\n      background-color: transparent !important;\n      border: none !important;\n      box-shadow: none !important;\n      outline: none !important;\n    }\n\n    mat-icon {\n      font-size: 24px;\n      width: 24px;\n      height: 24px;\n      background: transparent !important;\n      background-color: transparent !important;\n      border: none !important;\n      box-shadow: none !important;\n    }\n  }\n}\n\n// Content Area\n.analytics-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0;\n  -webkit-overflow-scrolling: touch;\n\n  .mat-mdc-tab-group {\n    height: 100%;\n\n    .mat-mdc-tab-body-wrapper {\n      height: calc(100% - 48px);\n    }\n  }\n\n  .mat-mdc-tab-body-content {\n    height: 100%;\n    overflow-y: auto;\n    padding: 20px 24px;\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n// Time Period Selector\n.time-period-selector {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 24px;\n  padding: 16px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e0e0e0;\n\n  label {\n    font-weight: 600;\n    color: #333;\n    margin: 0;\n    white-space: nowrap;\n  }\n\n  .time-period-select {\n    padding: 8px 12px;\n    border: 1px solid #ccc;\n    border-radius: 6px;\n    background: white;\n    font-size: 14px;\n    min-width: 120px;\n    cursor: pointer;\n\n    &:focus {\n      outline: 2px solid #333;\n      outline-offset: 2px;\n    }\n  }\n}\n\n// Charts Grid\n.charts-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 24px;\n  margin-bottom: 24px;\n\n  .chart-container {\n    background: #fff;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    padding: 20px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    transition: box-shadow 0.2s ease;\n\n    &:hover {\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    }\n\n    h4 {\n      margin: 0 0 16px 0;\n      font-size: 16px;\n      font-weight: 600;\n      color: #333;\n      text-align: center;\n    }\n\n    canvas {\n      width: 100% !important;\n      height: 300px !important;\n      max-height: 300px;\n    }\n  }\n}\n\n// Links Tab full-height wrapper — keeps the modal the same size as the Overview tab\n.links-tab-body {\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n  height: 100%;\n}\n\n// Empty state for Links tab\n.links-empty-state {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 24px;\n  text-align: center;\n  color: #999;\n\n  .links-empty-icon {\n    font-size: 56px;\n    width: 56px;\n    height: 56px;\n    color: #ccc;\n    margin-bottom: 16px;\n  }\n\n  .links-empty-title {\n    margin: 0 0 8px 0;\n    font-size: 16px;\n    font-weight: 600;\n    color: #666;\n  }\n\n  .links-empty-sub {\n    margin: 0;\n    font-size: 13px;\n    color: #aaa;\n    max-width: 320px;\n    line-height: 1.5;\n  }\n}\n\n// Links Table\n.links-table-container {\n  overflow-x: auto;\n  border-radius: 8px;\n  border: 1px solid #e0e0e0;\n  background: white;\n\n  .links-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin: 0;\n\n    thead {\n      background: #f8f9fa;\n\n      th {\n        padding: 16px 12px;\n        text-align: left;\n        font-weight: 600;\n        color: #333;\n        font-size: 14px;\n        white-space: nowrap;\n        border-bottom: 2px solid #e0e0e0;\n      }\n    }\n\n    tbody {\n      tr {\n        border-bottom: 1px solid #e0e0e0;\n        transition: background-color 0.2s ease;\n\n        &:hover {\n          background-color: #f8f9fa;\n        }\n\n        &:last-child {\n          border-bottom: none;\n        }\n\n        td {\n          padding: 12px;\n          font-size: 14px;\n          color: #333;\n          vertical-align: top;\n\n          &.link-cell {\n            max-width: 300px;\n            word-break: break-all;\n\n            a {\n              color: #333;\n              text-decoration: none;\n              font-weight: 500;\n\n              &:hover {\n                text-decoration: underline;\n                color: #000;\n              }\n            }\n          }\n\n          &.clicks-cell {\n            text-align: center;\n            font-weight: 600;\n            color: #333;\n          }\n        }\n      }\n    }\n  }\n}\n\n// Loading Spinner\n.loading-spinner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  color: #666;\n\n  mat-spinner {\n    margin-bottom: 16px;\n  }\n\n  p {\n    margin: 0;\n    font-size: 14px;\n  }\n}\n\n// Mobile Responsiveness\n@media (max-width: 768px) {\n  .analytics-dialog-container {\n    max-height: 100vh;\n    max-width: 100vw;\n    margin: 0;\n    border-radius: 0;\n    height: 100vh;\n    width: 100vw;\n  }\n\n  .analytics-header {\n    padding: 16px 20px;\n    min-height: 56px;\n\n    .analytics-title h2 {\n      font-size: 20px;\n    }\n\n    .close-button {\n      min-width: 36px;\n      min-height: 36px;\n      margin-left: 12px;\n\n      mat-icon {\n        font-size: 20px;\n        width: 20px;\n        height: 20px;\n      }\n    }\n  }\n\n  .analytics-content {\n    .mat-mdc-tab-body-content {\n      padding: 16px 20px;\n    }\n  }\n\n  .time-period-selector {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n    padding: 12px;\n\n    .time-period-select {\n      width: 100%;\n      min-width: unset;\n    }\n  }\n\n  .charts-grid {\n    grid-template-columns: 1fr;\n    gap: 16px;\n\n    .chart-container {\n      padding: 16px;\n\n      h4 {\n        font-size: 14px;\n        margin-bottom: 12px;\n      }\n\n      canvas {\n        height: 250px !important;\n        max-height: 250px;\n      }\n    }\n  }\n\n  .links-table-container {\n    .links-table {\n      thead th {\n        padding: 12px 8px;\n        font-size: 12px;\n      }\n\n      tbody td {\n        padding: 8px;\n        font-size: 12px;\n\n        &.link-cell {\n          max-width: 200px;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .analytics-dialog-container {\n    max-height: 100vh;\n    max-width: 100vw;\n    margin: 0;\n    border-radius: 0;\n    height: 100vh;\n    width: 100vw;\n  }\n\n  .analytics-header {\n    padding: 12px 16px;\n    min-height: 52px;\n\n    .analytics-title h2 {\n      font-size: 18px;\n    }\n  }\n\n  .analytics-content {\n    .mat-mdc-tab-body-content {\n      padding: 12px 16px;\n    }\n  }\n\n  .charts-grid {\n    .chart-container {\n      padding: 12px;\n\n      canvas {\n        height: 200px !important;\n        max-height: 200px;\n      }\n    }\n  }\n}\n\n// Landscape Mode Responsive Popup\n@media (orientation: landscape) and (max-height: 600px) {\n  .analytics-dialog-container {\n    max-height: 95vh;\n    max-width: 80vw;\n  }\n\n  .analytics-content {\n    .mat-mdc-tab-body-content {\n      padding: 12px 16px;\n    }\n  }\n\n  .charts-grid {\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 16px;\n\n    .chart-container {\n      padding: 12px;\n\n      h4 {\n        font-size: 14px;\n        margin-bottom: 8px;\n      }\n\n      canvas {\n        height: 200px !important;\n        max-height: 200px;\n      }\n    }\n  }\n}\n\n// Accessibility improvements\n@media (prefers-reduced-motion: reduce) {\n  .chart-container,\n  .close-button,\n  .links-table tbody tr {\n    transition: none;\n  }\n}\n\n// High contrast mode support\n@media (prefers-contrast: high) {\n  .analytics-dialog-container {\n    border: 2px solid #000;\n  }\n\n  .analytics-header {\n    background: #f8f9fa;\n    color: #000;\n    border: 2px solid #000;\n  }\n\n  .chart-container {\n    border: 2px solid #000;\n  }\n\n  .links-table {\n    border: 2px solid #000;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
